import axios from "axios";
import { getUrl, firebaseConfig } from "@/common/config";
import store from "@/stores/store";
import { getApps, initializeApp } from "firebase/app";
import { getToken, isSupported, onMessage, getMessaging } from "firebase/messaging";

async function sendTokenToServer(token) {
  return axios.post(
    `${getUrl()}/api/users/${this.me}/subscriptions/push`,
    { regToken: token, app: "uwa" },
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
}

export async function initializeNotifications(userId) {
  try {
    const apps = getApps();

    if (apps.length === 0) {
      initializeApp(firebaseConfig);

      const supported = await isSupported();

      if (supported) {
        const messaging = getMessaging();

        onMessage(messaging, payload => {
          console.log("[Firebase] Received foreground message:", payload);
          try {
            store.dispatch("User/Notifications/newNotification");
          } catch (e) {
            console.error(`[Firebase] New notification send error: ${e}`);
          }
        });

        if (Notification.permission !== "denied") {
          try {
            const token = await getToken(messaging);
            await sendTokenToServer(token, userId);

            console.log(`[Firebase] Push notification initialized!`);
          } catch (e) {
            console.error(`[Firebase] Cannot initialize push notifications. Error: ${e}`);
          }
        }
      } else {
        console.error(
          `[Firebase] Required APIs not exist in the browser. Firebase not initialized.`
        );
      }
    }
  } catch (e) {
    console.error(`[Firebase] Cannot initialize push notifications. Error: ${e}`);
  }
}
